import React from 'react';
import { Reveal } from '../Reveal';
import type { CaseStudyDecision } from '../../types/content';
interface DecisionListProps {
  decisions: CaseStudyDecision[];
}
export function DecisionList({
  decisions
}: DecisionListProps) {
  return <ol className="border-t border-hairline" data-id="element-178" data-mp="25uv87rwcq5gl">
      {decisions.map((item, index) => <Reveal as="li" key={item.decision} delay={index * 0.06} data-id="element-179" data-mp="2at6i22mncfyt" data-mpi={index}>
          <div className="grid gap-3 border-b border-hairline py-7 md:grid-cols-12 md:gap-8" data-id="element-180" data-mp="1wu6vr1mlwd5t">
            <p className="text-small tabular-nums text-muted md:col-span-1" data-id="element-181" data-mp="21ucgdxugkzee">
              {String(index + 1).padStart(2, '0')}
            </p>
            <h3 className="text-[20px] leading-[1.3] tracking-[-0.02em] text-ink md:col-span-5" data-id="element-182" data-mp="1my3m7apfdc8u">
              {item.decision}
            </h3>
            <p className="text-body text-muted md:col-span-6" data-id="element-183" data-mp="3hatdrlsbm9d2">{item.reasoning}</p>
          </div>
        </Reveal>)}
    </ol>;
}